// Utility functions for Storefront API data transformation

export const transformProductForStorefront = (product) => {
  if (!product) return null;

  return {
    id: product.id,
    title: product.title,
    handle: product.handle,
    description: product.description,
    images:
      product.images?.edges?.map((edge) => ({
        src: edge.node.url,
        altText: edge.node.altText,
      })) || [],
    variants:
      product.variants?.edges?.map((edge) => ({
        id: edge.node.id,
        title: edge.node.title,
        price: {
          amount: edge.node.price.amount,
          currencyCode: edge.node.price.currencyCode,
        },
        availableForSale: edge.node.availableForSale,
      })) || [],
  };
};

export const transformCartLineItem = (lineItem) => {
  if (!lineItem) return null;

  const product = lineItem.merchandise.product;
  const variant = lineItem.merchandise;

  return {
    id: lineItem.id,
    quantity: lineItem.quantity,
    title: product.title,
    variant: {
      id: variant.id,
      title: variant.title,
      price: {
        amount: variant.price.amount,
        currencyCode: variant.price.currencyCode,
      },
      product: {
        id: product.id,
        title: product.title,
        handle: product.handle,
      },
      image: product.images?.edges?.[0]?.node
        ? {
            src: product.images.edges[0].node.url,
            altText: product.images.edges[0].node.altText,
          }
        : null,
    },
  };
};

export const getItemPriceStorefront = (lineItem) => {
  if (!lineItem?.merchandise?.price) return 0;
  return parseFloat(lineItem.merchandise.price.amount);
};

export const getLinePriceStorefront = (lineItem) => {
  const itemPrice = getItemPriceStorefront(lineItem);
  return itemPrice * lineItem.quantity;
};

export const getCartTotalStorefront = (cart) => {
  if (!cart?.cost?.totalAmount) return 0;
  return parseFloat(cart.cost.totalAmount.amount);
};

export const getCartSubtotalStorefront = (cart) => {
  if (!cart?.cost?.subtotalAmount) return 0;
  return parseFloat(cart.cost.subtotalAmount.amount);
};

export const getCartTaxStorefront = (cart) => {
  if (!cart?.cost?.totalTaxAmount) return 0;
  return parseFloat(cart.cost.totalTaxAmount.amount);
};

// Convert legacy variant ID to Storefront API format
export const convertToStorefrontVariantId = (legacyVariantId) => {
  // If it's already a Storefront API ID, return as-is
  if (
    typeof legacyVariantId === "string" &&
    legacyVariantId.startsWith("gid://")
  ) {
    return legacyVariantId;
  }

  // Convert numeric ID to Storefront API format
  return `gid://shopify/ProductVariant/${legacyVariantId}`;
};

// Convert legacy product ID to Storefront API format
export const convertToStorefrontProductId = (legacyProductId) => {
  // If it's already a Storefront API ID, return as-is
  if (
    typeof legacyProductId === "string" &&
    legacyProductId.startsWith("gid://")
  ) {
    return legacyProductId;
  }

  // Convert numeric ID to Storefront API format
  return `gid://shopify/Product/${legacyProductId}`;
};
